import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import safeStorage from '@/lib/safeStorage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = 'smb_site_images';

const SiteImagesContext = createContext({});

export function SiteImagesProvider({ children }) {
  const [images, setImages] = useState(() => safeStorage.get(CACHE_KEY) || {});

  useEffect(() => {
    axios.get(`${API}/site-images`)
      .then(r => {
        setImages(r.data);
        safeStorage.set(CACHE_KEY, r.data);
      })
      .catch(() => {});
  }, []);

  return <SiteImagesContext.Provider value={images}>{children}</SiteImagesContext.Provider>;
}

export function useSiteImage(key) {
  const images = useContext(SiteImagesContext);
  return images[key] || '';
}

export function useSiteImages() {
  return useContext(SiteImagesContext);
}

export default SiteImagesContext;
